import React, { FC, useEffect, useState, memo } from "../../../lib/teact/teact";
import Button from "../../ui/Button";
import { DBManager } from "../db/dbManager";
import Snackbar from "../ui/snackbar";
import './tuKhoaRieng.scss'
type OwnProps = {
    onSaveData: () => void;
}

const TuKhoaRieng: FC<OwnProps> = ({
    onSaveData,
}) => {
    const [state, setState] = useState({
        tuKhoaRieng: [] as any[],
        flipData: false,
        showSnackbar: false,
        snackbarText: "",
    })
    useEffect(() => {
        DBManager.readDataAllFromTable("tuKhoaRieng").then((result: any[]) => {
            const tmp: any[] = []
            result.map(record => {
                tmp.push(record)
            })
            setState(prev => ({ ...prev, tuKhoaRieng: tmp }))
        })
    }, [state.flipData])
    function handleRemoveItem(index: number) {
        const tmp = [...state.tuKhoaRieng]
        tmp.splice(index, 1)
        setState((prev: any) => ({ ...prev, tuKhoaRieng: tmp }))
    }
    function handleAddItem() {
        const userId = Number(localStorage["userId"])
        const mienCuPhapId = Number(localStorage["mienCuPhapId"])
        const newItem = {
            userId: userId,
            mienCuPhapId: mienCuPhapId,
            tuKhoa: "",
            thayBangTuKhoa: ""
        }
        const found = state.tuKhoaRieng.filter((record: any) => {
            let notOk = true
            notOk = record.tuKhoa == newItem.tuKhoa && record.thayBangTuKhoa == newItem.thayBangTuKhoa
            notOk = notOk || record.tuKhoa == ''
            notOk = notOk || record.thayBangTuKhoa == ''
            return notOk
        })
        if (found.length == 0) {
            const tmp = { ...state }
            tmp.tuKhoaRieng.push(newItem)
            setState((prev: any) => ({ ...prev, tuKhoaRieng: tmp.tuKhoaRieng }))
        }
    }
    function handleTuKhoaChange(index: number, e: any) {
        const tmp = [...state.tuKhoaRieng]
        const record = tmp[index]
        record.tuKhoa = e.target.value
        tmp[index] = record
        setState((prev: any) => ({ ...prev, tuKhoaRieng: tmp }))
    }
    function handleThayBangTuKhoaChange(index: number, e: any) {
        const tmp = [...state.tuKhoaRieng]
        const record = tmp[index]
        record.thayBangTuKhoa = e.target.value
        tmp[index] = record
        setState((prev: any) => ({ ...prev, tuKhoaRieng: tmp }))
    }
    async function handleSaveData() {
        const clear = new Promise((resolve, reject) => {
            DBManager.getDBConnection().then(db => {
                const objstore = db.transaction("tuKhoaRieng", "readwrite").objectStore("tuKhoaRieng").clear()
                resolve(1)
            })
        })
        await clear
        const promises: Promise<any>[] = []
        state.tuKhoaRieng.map((record: any) => {
            const promise = new Promise((resolve, reject) => {
                DBManager.getDBConnection().then(db => {
                    const objstore = db.transaction("tuKhoaRieng", "readwrite").objectStore("tuKhoaRieng")
                    record.tuKhoa = record.tuKhoa.toLowerCase().trim()
                    record.thayBangTuKhoa = record.thayBangTuKhoa.toLowerCase().trim()
                    objstore.put(record)
                    resolve(1)
                })
            })
            promises.push(promise)
        })
        await Promise.all(promises)
        setState(prev => ({ ...prev, flipData: !prev.flipData }))
        onSaveData()
    }
    return (
        <>
            <div className="tuKhoaRieng-header">
                <div className="header">
                    Từ khoá
                </div>
                <div className="header">
                    Thay bởi từ khoá
                </div>
                <div className="right-panel">
                    <Button round color="translucent" size="smaller"
                        onClick={handleAddItem}
                    >
                        <i className="icon icon-add" />
                    </Button>
                    <Button round color="translucent" size="smaller"
                        onClick={handleSaveData}
                    >
                        <i className=" fa-solid fa-floppy-disk" />
                    </Button>
                </div>

            </div>
            {
                state.tuKhoaRieng.map((record: any, index: number) => {
                    return (
                        <div className="tuKhoaRieng-container" id={index}>
                            <input className="input" value={record.tuKhoa}
                                onChange={(e) => handleTuKhoaChange(index, e)}
                            >

                            </input>
                            <input className="input" value={record.thayBangTuKhoa}
                                onChange={(e) => handleThayBangTuKhoaChange(index, e)}
                            >

                            </input>
                            <div className="right-panel">
                                <Button round color="translucent" size="smaller"
                                    onClick={() => handleRemoveItem(index)}

                                >
                                    <i className="icon icon-remove" />
                                </Button>
                            </div>
                        </div>

                    )
                })
            }
            <Snackbar isOpen={state.showSnackbar} message={state.snackbarText}
                triggerTime="3000"
                onClose={() => setState(prev => ({ ...prev, showSnackbar: false }))}>
            </Snackbar>
        </>
    )
}

export default memo(TuKhoaRieng);